import { render } from "./WelcomeComp.vue?vue&type=template&id=0d2ce7ab"
import script from "./WelcomeComp.vue?vue&type=script&lang=js"
export * from "./WelcomeComp.vue?vue&type=script&lang=js"
script.render = render

export default script